import React from 'react';
import PropTypes from 'prop-types';

import { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import Slider from '../../../01_atoms/Slider';
import Spinner from '../../../01_atoms/Spinner';
import ItemWithLogo from '../../../02_molecules/Item/ItemWithLogo';
import { LinkChevron } from '../../../02_molecules/Link';
import { PTItemWithLogo } from '../../../02_molecules/Item/ItemWithLogo/prop-types';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

class BBFunders extends React.Component {
  sliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    beforeChange: this.onBeforeSlideChange.bind(this),
    afterChange: this.onAfterSlideChange.bind(this),
  };

  constructor(props) {
    super(props);

    this.state = {
      activeSlideIndex: 0,
      transitioning: false,
    };
  }

  onBeforeSlideChange() {
    this.setState((state) => ({ ...state, transitioning: true }));
  }

  onAfterSlideChange(index) {
    this.setState({ activeSlideIndex: index, transitioning: false });
  }

  render() {
    const { title, seeAll, funders, behaviorSettings, uuid } = this.props;
    const { activeSlideIndex, transitioning } = this.state;

    if (!(funders && funders.length)) {
      return null;
    }

    const classes = [
      'bb',
      'bb-funders',
      styles['bb-funders'],
      generateClassNameByBehaviorSettings(behaviorSettings),
    ];

    return (
      <div
        className={classes.join(' ')}
        id={uuid}
        // Hide BBSidebarTableOfContents when it is nearby the element.
        data-toc="hide"
      >
        <div className="container">
          <div className="wrapper">
            <div className="d-flex justify-content-between">
              {title && <h2 className="rockitt">{title}</h2>}

              {seeAll && seeAll.label && seeAll.nextLink && (
                <div className="d-none d-lg-block align-self-center link-container">
                  <LinkChevron label={seeAll.label} nextLink={seeAll.nextLink} />
                </div>
              )}
            </div>

            <div className="d-none d-md-flex row">
              {funders.map((funder) => (
                <div key={funder.name} className="col-md-12 col-lg-6">
                  <ItemWithLogo key={funder.name} {...funder} />
                </div>
              ))}
            </div>

            <div className="d-md-none slider-container">
              <Slider {...this.sliderSettings}>
                {funders.map((funder) => (
                  <ItemWithLogo key={funder.name} {...funder} />
                ))}
              </Slider>

              <div className="text-center counter">
                {transitioning ? (
                  <Spinner color="turquoise" />
                ) : (
                  <p>
                    <strong>
                      {activeSlideIndex + 1}/{funders.length}
                    </strong>
                  </p>
                )}
              </div>
            </div>

            {seeAll && seeAll.label && seeAll.nextLink && (
              <div className="d-lg-none text-center link-container">
                <LinkChevron label={seeAll.label} nextLink={seeAll.nextLink} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

BBFunders.propTypes = {
  title: PropTypes.string.isRequired,
  seeAll: PropTypes.shape({
    label: PropTypes.string,
    nextLink: PropTypes.shape(linkPropTypes),
  }),
  funders: PropTypes.arrayOf(PropTypes.shape(PTItemWithLogo)).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

BBFunders.defaultProps = {
  seeAll: null,
  behaviorSettings: null,
  uuid: null,
};

export default BBFunders;
